export function initPayrexxFrame() {
  const payrexxFrame = document.querySelector("#payrexx-embed")
  if (payrexxFrame) {
    let firstLoad = true
    payrexxFrame.addEventListener("load", (e) => {
      firstLoad ? (firstLoad = false) : payrexxFrame.scrollIntoView()
    })
  }
}
